import $ from "jquery";

import niceNumber from "./vendor/niceNumber.js";

const form = () => {
  if (document.querySelector(".input-number")) {
    $(".input-number").niceNumber();
  }
};

export default form;
